import { Entity } from '../common-models/Entity';
import { CustomerRecipe } from './CustomerRecipe';
import { ProductRecipeLinkingRequestItem } from './ProductRecipeLinkingRequestItem';
import { User } from './User';

export class ProductRecipeLinkingRequest extends Entity {
  customerRecipeId: number;
  customerRecipe?: CustomerRecipe;
  orderId?: number;
  shopifyOrderId?: number;
  frameSku: string;
  lensSku: string;
  createdAt: Date;
  updatedAt?: Date;
  linkConfirmed: boolean;
  linkedById?: number;
  linkedBy: User;
  items: ProductRecipeLinkingRequestItem[];
  pairNumber: number;
}